module.exports = __webpack_public_path__ + "img/brand-isuzu.2b6973db.png";